import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useUserPrint } from '@app/hooks';
import { NotificationContext } from '@app/providers';
import { handleCatchError, useGetSalesFunnelStagesQuery } from '@app/services';
import type { NFunnels } from '@app/types';

export const useViewSalesFunnelEffects = () => {
  const [query] = useSearchParams();
  const id = query.get('id');

  const [currentSalesFunnelStages, setCurrentSalesFunnelStages] = useState<
    NFunnels.SalesFunnelStageListDto[]
  >([]);

  const { activeBranchId } = useUserPrint();

  const { showNotification } = useContext(NotificationContext);

  const {
    data: currentSalesFunnelStagesData,
    error: salesFunnelStagesError,
    isLoading: isStageFunnelLoading,
    refetch: refetchGetSalesFunnelStage,
  } = useGetSalesFunnelStagesQuery(
    {
      salesFunnelId: id,
      ActiveBranchId: activeBranchId,
    },
    {
      skip: !activeBranchId || !id,
    }
  );

  useEffect(() => {
    refetchGetSalesFunnelStage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentSalesFunnelStagesData) {
      setCurrentSalesFunnelStages(currentSalesFunnelStagesData);
    }
  }, [currentSalesFunnelStagesData, setCurrentSalesFunnelStages]);

  useEffect(() => {
    if (salesFunnelStagesError) {
      showNotification(handleCatchError(salesFunnelStagesError));
    }
  }, [showNotification, salesFunnelStagesError]);

  return {
    currentSalesFunnelStages,
    isStageFunnelLoading,
  };
};
